import type { FaireProductEntity } from "../../entity_types/product";

export const p_5b693e5wtn: FaireProductEntity = {
  token: "p_5b693e5wtn",
  type: "product",
  name: "18K Gold Filled Clear Gold-Lined Nautilus Sea Shell Drop Pendant | AF291",
  brandName: "Aim Eternal",
  imageUrl:
    "https://cdn.faire.com/fastly/23ade6db8e57708b236f65b7889846d62b5d6aaea1dc685160103b1b9585ab42.jpeg",
  priceDollars: 2.25,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/95354c28af2b170675dd88e68db58aa7f095cd499ce69ec13f6cdbb3f6a472f2.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
